import { useEventListener } from '@vueuse/core';
import { nextTick } from 'vue';

export default function useThemeChange(fn: () => any) {
  return useEventListener(
    document.getElementById('app'),
    'uc:themechange',
    () => {
      nextTick(fn);
    }
  );
}

export function dispatchThemeChange() {
  document
    .getElementById('app')
    ?.dispatchEvent(new CustomEvent('uc:themechange'));
}
